import { useNavigate } from "react-router-dom";
import Paths from "../../../paths";
import pagey from "./../../../assets/pagey.png";
import { LogoutContainer, LogoutLayout } from "./logoutStyled";
import { LoginButton } from "../../../style/layouts";

export default function Login() {
  const history = useNavigate();

  const login = () => {
    history(Paths.Base);
  };

  return (
    <LogoutContainer>
      <LogoutLayout>
        <h1>Your session has been closed!</h1>
        <img src={pagey} alt="pagey"></img>
        <LoginButton onClick={() => login()}>Go back to Login</LoginButton>
      </LogoutLayout>
    </LogoutContainer>
  );
}
